const getColor = (colorData) => {
  if (colorData != null) {
    if (colorData.preset_color != null) {
      return getColorVariable(colorData.preset_color);
    } else if (colorData.custom_color != null) return colorData.custom_color;
  }
  return 'Shark'; // use Shark as default color
};

const getColorVariable = (colorName) => {
  switch (colorName) {
    default:
    case 'Dark Gray':
      return 'Shark';
    case 'Mid Gray':
      return 'Pensive';
    case 'Light Gray':
      return 'Athens';
  }
};

const getColorHex = (colorData) => {
  if (colorData != null) {
    if (colorData.preset_color != null) {
      // return getColorVariable(colorData.preset_color);
      switch (colorData.preset_color) {
        default:
        case 'Dark Gray':
          return '#2b2c33'; // Shark
        case 'Mid Gray':
          return '#84869a'; // Pensive
        case 'Light Gray':
          return '#dbdce6'; // Athens
      }
    } else if (colorData.custom_color != null) return colorData.custom_color;
  }
  return '#2b2c33'; // use Shark as default color
};

const getTextColor = (colorName) => {
  switch (colorName) {
    default:
    case 'Midnight':
    case 'Mulberry':
    case 'Yonder':
      return 'Milk';
    case 'Danube':
    case 'Sky':
    case 'Ice':
    case 'Milk':
      return 'Midnight';
  }
};

const getAwardColor = (colorName) => {
  switch (colorName) {
    case 'Platinum':
      return 'Platinum';
    case 'Gold':
      return 'Gold';
    case 'Silver':
      return 'Silver';
    case 'Blue':
      return 'Danube';
    case 'Light Blue':
      return 'Sky';
    default:
      return 'Danube';
  }
};

const isHex = (colorName) => {
  return colorName.charAt(0) === '#';
};

export { getAwardColor, getColorHex, getColorVariable, getTextColor, isHex };
export default getColor;
